import React , { Component } from 'react'
import './index.css'
import leftImg from '../../images/img_lefttupian@2x.png'

export default class LoginLeftCont extends Component{
    render() {
        const {leftDes1, leftDes2, leftTitle} = this.props
        return (
            <div className="leftCont">
                <h2>{leftTitle}</h2>
                <p className="set1">{leftDes1}</p>
                <p className="set2">{leftDes2}</p>
                {/* <div className="imgBox">
                    <img src={leftImg} alt=""/>
                </div> */}
            </div>
        );
    }
}